import { useEncounter } from '@/contexts/encounter-context';
import { useGetEncountersQuestions } from '@/api/get-questions';
import { useGetEncountersResponses } from '@/api/get-vq-responses';
import { VariableQuestionsForm } from '@/components/encounter/variable-questions/variable-question-form';
import { Navigate, useParams } from '@/util/react-router-dom';
import { GetQuestionsByPageErrorType } from '@/api/api.schemas';
import { Loader } from '@/components/loaders/loader';

export function VariableQuestionsPage() {
  const { encounter } = useEncounter();
  const { pageId } = useParams();
  const pageIdNum = pageId ? Number(pageId) : undefined;
  const {
    data: questionsData,
    isFetching: isFetchingQuestions,
    error: questionsError,
  } = useGetEncountersQuestions(encounter.id, { pageId: pageIdNum });

  const {
    data: responsesData,
    isFetching: isFetchingResponses,
    refetch,
  } = useGetEncountersResponses(encounter.id);

  if (questionsError) {
    return questionsError.type === GetQuestionsByPageErrorType.NotFound ? (
      <Navigate to="/not-found" />
    ) : (
      <Navigate to={`/visit/${encounter.id}/questions`} />
    );
  }

  if (isFetchingQuestions || isFetchingResponses) {
    return <Loader type="large" />;
  }

  if (!questionsData || !responsesData) {
    return null;
  }

  return (
    <VariableQuestionsForm
      questionsData={questionsData}
      responsesData={responsesData}
      onSubmit={refetch}
    />
  );
}
